import FormikLabeledInput from './FormikLabeledInput';

export default FormikLabeledInput;
